//import '/node_modules/@splidejs/splide/dist/css/splide.min.css';
//import '../css/detail.scss';
import * as prdDetailScript from './_detail_products.js';
import layzyload from 'layzyload';


window.addEventListener('DOMContentLoaded', function(){
	prdDetailScript.init();
});


